import React, { Fragment } from "react";
import BugHunterStatisticsPage from "./BugHunterStatisticsPage";

const PublicBugHunterStatisticsPage: React.FC = () => {
  return (
    <Fragment>
      <div style={{ 
        padding: '20px',
        background: '#f5f5f5',
        minHeight: '100vh'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '30px',
            paddingBottom: '20px',
            borderBottom: '2px solid #f0f0f0'
          }}>
            <h1 style={{
              color: '#1890ff',
              fontSize: '28px',
              fontWeight: 'bold',
              margin: '0 0 10px 0'
            }}>
              🏆 Thống Kê Sao
            </h1>
            <p style={{
              color: '#666',
              fontSize: '16px',
              margin: 0
            }}>
              Bảng xếp hạng theo sao BUG và sao IDEA
            </p>
          </div>
          
          <BugHunterStatisticsPage />
        </div>
      </div>
    </Fragment>
  );
};

export default PublicBugHunterStatisticsPage;
